<template>
  <div class="section-content section1">
    <div class="content-wrapper">
      <div class="text-content" :class="{'animate__show': isActive}">
        <h1>SMART GLASSES</h1>
        <div class="subtitle">See smarter, live smarter</div>
        <p class="description">
          以适合全天候使用的透明光波导技术为基础，创新轻量无线，一体化设计，将又快又准的语音转文字技术带入全新移动字幕体验，让"声音"实时在眼前。
        </p>
      </div>
      <div class="image-content" :class="{'animate__show': isActive}">
        <img src="../assets/glasses1.png" alt="Smart Glasses">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section1',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.section-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #000;
  color: #fff;
  padding: 0;
  position: relative;
}

.content-wrapper {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

.text-content {
  position: relative;
  z-index: 2;
  padding-left: 8%;
  padding-top: 8%;
  opacity: 0;
  transform: translateX(-50px);
  transition: all 0.8s ease;
}

.text-content.animate__show {
  opacity: 1;
  transform: translateX(0);
}

h1 {
  font-size: 60px;
  margin-bottom: 30px;
  font-weight: bold;
  position: relative;
  display: inline-block;
}

h1::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #42b983;
}

.subtitle {
  font-size: 25px;
  color: #42b983;
  margin-bottom: 30px;
}

.description {
  font-size: 25px;
  line-height: 1.6;
  color: #999;
  max-width: 450px;
}

.image-content {
  position: absolute;
  top: -5%;
  right: -5%;
  width: 85%;
  height: 110%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transform: translateX(50px);
  transition: all 0.8s ease;
  z-index: 1;
}

.image-content.animate__show {
  opacity: 1;
  transform: translateX(0);
}

.image-content img {
  max-width: 100%;
  height: auto;
}

@media screen and (max-width: 768px) {
  .content-wrapper {
    display: flex;
    flex-direction: column;
    padding: 60px 32px;
  }

  .text-content {
    padding: 0;
    text-align: center;
    margin-bottom: 40px;
  }

  h1 {
    font-size: 48px;
    margin-bottom: 24px;
  }

  h1::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .subtitle {
    font-size: 32px;
    margin-bottom: 24px;
  }

  .description {
    font-size: 24px;
    max-width: 100%;
    margin: 0 auto;
  }

  .image-content {
    position: relative;
    top: 0;
    right: 0;
    width: 100%;
    height: auto;
    margin-top: 0;
  }

  .image-content img {
    width: 100%;
    margin: 0 auto;
  }
}
</style> 